// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1_PVG","cls2":"CreateSocialItem-cls2_NF6 CreateSocialItem-cls1_PVG"};